import { Icon } from '@chakra-ui/react';

export const PerformanceHistory = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M4 19.4333C4 19.1572 4.22386 18.9333 4.5 18.9333H19.5C19.7761 18.9333 20 19.1572 20 19.4333V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V19.4333Z"
      fill="currentColor"
    />
    <path
      d="M9.33333 16.2333C9.33333 15.9572 9.55719 15.7333 9.83333 15.7333H19.5C19.7761 15.7333 20 15.9572 20 16.2333V16.3C20 16.5761 19.7761 16.8 19.5 16.8H9.83333C9.55719 16.8 9.33333 16.5761 9.33333 16.3V16.2333Z"
      fill="currentColor"
    />
    <path
      d="M14.6667 13.0333C14.6667 12.7572 14.8905 12.5333 15.1667 12.5333H19.5C19.7761 12.5333 20 12.7572 20 13.0333V13.1C20 13.3761 19.7761 13.6 19.5 13.6H15.1667C14.8905 13.6 14.6667 13.3761 14.6667 13.1V13.0333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1396 4.35129C15.9995 4.23013 16.0852 4 16.2704 4H19.5C19.7761 4 20 4.22386 20 4.5V7.73534C20 7.9199 19.7713 8.00597 19.6496 7.86722L18.4211 6.46653C18.3466 6.3816 18.2166 6.37518 18.1341 6.45237L12.7848 11.4576C12.5877 11.642 12.2798 11.6367 12.0892 11.4456L10.0659 9.41719C9.87777 9.22857 9.57478 9.2206 9.37698 9.39907L5.09318 13.2642C4.88779 13.4495 4.57097 13.4329 4.38617 13.227L4.33318 13.168C4.14904 12.9629 4.16564 12.6474 4.3703 12.4627L9.41603 7.91012C9.61383 7.73165 9.91683 7.73962 10.105 7.92824L12.115 9.94338C12.3057 10.1345 12.6136 10.1398 12.8107 9.95537L17.3599 5.69866C17.4467 5.61749 17.444 5.47904 17.3541 5.40133L16.1396 4.35129Z"
      fill="currentColor"
    />
  </Icon>
);
